import { Injectable } from '@angular/core';
import { environments } from '../../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  versionCore: string;
  buildInfo: string | null;
  version: string;

  constructor() {
    const version = environments.version.split('+');
    this.versionCore = version[0];
    this.buildInfo = version[1] ?? null;
    this.version = `${this.versionCore} (${this.buildInfo ?? ''})`;
  }

}
